import {
  Container,
} from "@chakra-ui/react"

import { createFileRoute } from "@tanstack/react-router"
import { z } from "zod"

import FeedsSection from "@/components/Reports/FeedsSection"
import ReportsSection from "@/components/Reports/ReportsSection"

const reportsSearchSchema = z.object({
  page: z.number().catch(1),
})

export const Route = createFileRoute("/_layout/reports")({
  component: Reports,
  validateSearch: (search) => reportsSearchSchema.parse(search),
})

function Reports() {
  return (
    <Container maxW="full" h="calc(100vh - 100px)" display="flex" flexDirection="column" pt={4} overflowY="auto">
      <FeedsSection />
      <ReportsSection />
    </Container>
  )
}
